import { objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isUsersPreferenceCenterResult = objectOf({
  success: boolean,
  id: string,
});
